export const ROOT_ID = "irobot-embedded-chart-v4";
